<template>
    <div v-if="isValidAttribute">
        <span class="is-description mr-2">
            <span class="icon">
                <i class="fas fa-tag"></i>
            </span>
            <span>{{ translate("pricing.price_for_specific_category") }}</span>
        </span>

        <span class="tag is-white" v-if="categoryNameForAttribute">
            {{ categoryNameForAttribute }}
        </span>

        <span v-for="(price, index) in prices" :key="index" class="tag is-info mr-1"> {{ price.value }} {{ price.currency }} </span>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../../Common/translations";
    import { CategoryDefinedPriceRawAttribute } from "../../Common/Pricing/types";
    import { usePricingSetupStore } from "../pricingSetupApp";

    const props = defineProps<{
        attribute: CategoryDefinedPriceRawAttribute;
    }>();
    const store = usePricingSetupStore();
    const prices = computed(() => {
        return props.attribute.value.prices.map(({ value, currency }) => {
            return {
                value: value,
                currency: currency,
            };
        });
    });

    const categoryNameForAttribute = computed(() => {
        const category = store.allLevelsCategories.find(c => c.key === props.attribute.value.parameterId);
        return category?.value || "";
    });

    const isValidAttribute = computed(() => {
        return categoryNameForAttribute.value !== "";
    });
</script>

<style scoped></style>
